import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Segment, Button, List, Icon, Header, Label } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import { formatPrice } from '../../../helpers/format';
import { updateUrlState } from '../../../helpers/url';
import { fetchLoyaltyProgramMembers, fetchMemberPurchaseHistory } from '../../../actions';

import './MemberDetails.scss';

class MemberDetails extends Component {

    componentWillMount() {
        const {
            loyaltyProgram,
            loyaltyProgramId,
            memberId,
            fetchLoyaltyProgramMembers,
            fetchMemberPurchaseHistory
        } = this.props;

        if (loyaltyProgram && loyaltyProgram.membersIds && memberId) {
            const lpMembers = loyaltyProgram.name === 'Paidit' ? null : loyaltyProgram.membersIds;
            fetchLoyaltyProgramMembers(loyaltyProgram.id, lpMembers);
            fetchMemberPurchaseHistory({ loyaltyProgramId, memberId });
        }
    }

    componentDidMount() {
        const queryParams = new URLSearchParams(this.props.location.search);
        if (!queryParams.has('sortCriteria')) {
            updateUrlState(this.props.history, this.props.location, { sortCriteria: 'createdAt', sortDirection: 'asc' });
        }
    }

    render() {
        const { history, meta, loyaltyProgram, member, memberHistoryReport } = this.props;

        if (!member) return null;

        if (!memberHistoryReport || !memberHistoryReport.length) {
            return <div className="pi-memeber-no-data">
                <Header as='h2' color='grey'>{i18next.t('dataGrid.noData')}</Header>
            </div>;
        }

        const orderTypes = ['sitting', 'takeaway', 'delivery'];

        const columns = [{
            id: 'index',
            Header: '#',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            Cell: row => ++row.index
        }, {
            Header: i18next.t('restaurant'),
            accessor: 'restaurant.name',
            filterable: true
        }, {
            id: 'orderType',
            Header: i18next.t('orderType'),
            accessor: purchase => purchase.order.cartType,
            Cell: row => row.value ? i18next.t(row.value) : '',
            filterable: true,
            filterValues: orderTypes.map(type => ({ value: type, text: i18next.t(type) }))
        }, {
            Header: i18next.t('loyaltyProgram.benefitName'),
            accessor: 'benefit.description',
            Cell: row => {
                const purchase = row.original;
                return <a href={`/loyaltyProgram/${purchase.benefit.loyaltyProgramId}/benefits/${purchase.benefit.id}`}>{row.value}</a>;
            },
            filterable: true
        }, {
            Header: i18next.t('loyaltyProgram.campaign'),
            accessor: 'campaign.name',
            Cell: row => {
                const purchase = row.original;
                return <a href={`/loyaltyProgram/${purchase.benefit.loyaltyProgramId}/campaigns/${purchase.issue.campaignId}`}>{row.value}</a>;
            },
            filterable: true
        }, {
            id: 'totalPrice',
            Header: i18next.t('totalPrice'),
            accessor: purchase => purchase.payment.amount,
            Cell: row => <span>{formatPrice(row.value)}</span>,
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 }
        }, {
            id: 'subsidy',
            Header: i18next.t('subsidy'),
            accessor: purchase => purchase.payment.benefitsSubsidy,
            Cell: row => <span>{formatPrice(row.value)}</span>,
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 }
        }, {
            id: 'createdAt',
            Header: i18next.t('createDate'),
            accessor: 'payment.createdAt',
            Cell: row => row.value ? new Date(row.value).toLocaleString() : null,
            filterable: true,
            filterDate: new Date()
        }];

        return (
            <section className="pi-member-container">
                <div className='pi-member-header-bar'>
                    <Header as='h2' size='huge'>
                        <Icon name='user' color='grey' />
                        <Header.Content>
                            {member.name}
                            <Header.Subheader>{member.email} ● {member.phone}</Header.Subheader>
                        </Header.Content>
                    </Header>
                    <List>
                        <List.Item><b>{i18next.t('user.gender')}</b>: {member.gender}</List.Item>
                        <List.Item><b>{i18next.t('birthdate')}</b>: {member.birthdate}</List.Item>
                    </List>
                    <Label>
                        {i18next.t('createDate')}
                        <Label.Detail>{new Date(member.createdAt).toLocaleString()}</Label.Detail>
                    </Label>
                </div>

                <div className="pi-member-usages-grid">
                    <DataGrid
                        data={memberHistoryReport}
                        columns={columns}
                        getTrGroupProps={(state, rowInfo, column) => {
                            return {};
                        }}
                        paginated
                       
                    />
                </div>

            </section>
        );
    }
}

MemberDetails.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    loyaltyProgram: PropTypes.object,
    memberHistoryReport: PropTypes.array,
    loyaltyProgramId: PropTypes.string,
    memberId: PropTypes.string,
    fetchLoyaltyProgramMembers: PropTypes.func,
    fetchMemberPurchaseHistory: PropTypes.func,
    
};

function mapStateToProps(state, ownProps) {
    const { meta } = state;
    const { benefits, members } = state.loyaltyApp;
    const { memberHistoryReport } = state.loyaltyApp.reports;
    const { loyaltyProgramId, memberId } = ownProps.match.params;
    const member = members.find(mem => mem.id === memberId);

    return { meta, loyaltyProgramId, benefits, memberId, member, memberHistoryReport };
}
export default connect(mapStateToProps, {
    fetchLoyaltyProgramMembers,
    fetchMemberPurchaseHistory
})(MemberDetails);
